import Image from "next/image";
import type { ReactNode } from "react";
import { assets } from "@/content/assets";
import { DonateFloatingLeaves } from "@/components/donate/DonateFloatingLeaves";
import { cn } from "@/lib/utils";

interface DonateImageBackdropProps {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  minHeight?: string;
  priority?: boolean;
  showLeaves?: boolean;
}

export function DonateImageBackdrop({
  children,
  className,
  contentClassName,
  minHeight = "min-h-[min(85vh,720px)]",
  priority = false,
  showLeaves = true,
}: DonateImageBackdropProps) {
  return (
    <section
      className={cn(
        "donate-image-backdrop relative overflow-hidden",
        minHeight,
        className
      )}
    >
      <Image
        src={assets.donateSunset}
        alt="Children holding hands at sunset — symbol of hope and community"
        fill
        priority={priority}
        sizes="100vw"
        className="donate-image-backdrop__photo object-cover"
      />

      <div
        className="donate-image-backdrop__scrim absolute inset-0"
        aria-hidden
      />

      {showLeaves && <DonateFloatingLeaves tone="light" />}

      <div className="relative z-10 flex h-full min-h-[inherit] items-center">
        <div
          className={cn(
            "donate-image-backdrop__content w-full max-w-xl px-6 py-14 md:max-w-2xl md:px-10 md:py-16 lg:px-14 lg:py-20",
            contentClassName
          )}
        >
          {children}
        </div>
      </div>
    </section>
  );
}
